// extracted by mini-css-extract-plugin
export default {"form":"CreateMapRoom_form__ic66z","buttonContainer":"CreateMapRoom_buttonContainer__Tnv9l","inputs":"CreateMapRoom_inputs__Hy6at"};